import React from 'react';

export const LazyCompanyPage = React.lazy(() => import('./CompanyPage'));
